
// Class ability score requirements (minimums, with 6s changed to 3s, Bard excluded)
const CLASS_REQUIREMENTS = {
  Cleric: { Str: 3, Int: 3, Wis: 9, Dex: 3, Con: 3, Cha: 3 },
  Druid: { Str: 3, Int: 3, Wis: 12, Dex: 3, Con: 3, Cha: 15 },
  Fighter: { Str: 9, Int: 3, Wis: 3, Dex: 3, Con: 7, Cha: 3 },
  Paladin: { Str: 12, Int: 9, Wis: 13, Dex: 3, Con: 9, Cha: 17 },
  Ranger: { Str: 13, Int: 13, Wis: 14, Dex: 3, Con: 14, Cha: 3 },
  'Magic-User': { Str: 3, Int: 9, Wis: 3, Dex: 3, Con: 3, Cha: 3 },
  Illusionist: { Str: 3, Int: 15, Wis: 3, Dex: 16, Con: 3, Cha: 3 },
  Thief: { Str: 3, Int: 3, Wis: 3, Dex: 9, Con: 3, Cha: 3 },
  Assassin: { Str: 12, Int: 11, Wis: 3, Dex: 12, Con: 3, Cha: 3 },
  Monk: { Str: 15, Int: 3, Wis: 15, Dex: 15, Con: 11, Cha: 3 }
};

// Race and class compatibility
const RACE_CLASSES = {
  Dwarf: ['Fighter', 'Thief', 'Assassin'],
  Elf: ['Fighter', 'Magic-User', 'Thief', 'Assassin'],
  Gnome: ['Fighter', 'Thief', 'Illusionist', 'Assassin'],
  'Half-Elf': ['Cleric', 'Fighter', 'Magic-User', 'Thief', 'Assassin'],
  Halfling: ['Fighter', 'Thief'],
  'Half-Orc': ['Cleric', 'Fighter', 'Thief', 'Assassin'],
  Human: ['Cleric', 'Druid', 'Fighter', 'Paladin', 'Ranger', 'Magic-User', 'Illusionist', 'Thief', 'Assassin', 'Monk']
};


function getAllowedClasses(charData) {

    let character = ( charData.stats ? charData.stats : charData )
    let race = ( charData.chars ) ? charData.chars.myRace : charData.myRace
    let eligibleClasses

  try {

    // calculate allowed classes based on abilities
    eligibleClasses = Object.keys(CLASS_REQUIREMENTS).filter(cls => {
      const reqs = CLASS_REQUIREMENTS[cls];
      return (
        parseInt(character.myStr) >= reqs.Str &&
        parseInt(character.myInt) >= reqs.Int &&
        parseInt(character.myWis) >= reqs.Wis &&
        parseInt(character.myDex) >= reqs.Dex &&
        parseInt(character.myCon) >= reqs.Con &&
        parseInt(character.myCha) >= reqs.Cha
      );
    });

    // filter eligible classes based on race
    eligibleClasses = eligibleClasses.filter(cls => RACE_CLASSES[race].includes(cls));

  } catch(error) {
    console.log(error)
  }

if (race === "Elf" || race === "Half-Elf") {
  if (eligibleClasses.includes("Fighter") && eligibleClasses.includes("Magic-User")) {
    eligibleClasses.push("F/MU");
  }
  if (eligibleClasses.includes("Thief")) {
    eligibleClasses.push("F/MU/Th");
  }
  if (eligibleClasses.includes("Fighter") && eligibleClasses.includes("Thief")) {
    eligibleClasses.push("F/Th");
  }
  if (eligibleClasses.includes("Magic-User") && eligibleClasses.includes("Thief")) {
    eligibleClasses.push("MU/Th");
  }
}

  return eligibleClasses

}

export default getAllowedClasses